
import { useCallback } from 'react';
import { DaySchedule } from './types';

export const useScheduleHelpers = (daySchedules: Map<string, DaySchedule>) => {
  const getScheduleForDate = useCallback((date: string): DaySchedule | null => {
    const schedule = daySchedules.get(date);
    
    console.log('🔧 [HOOK FIX] getScheduleForDate chamado:', {
      date,
      found: schedule ? 'yes' : 'no',
      hasSchedule: schedule?.hasSchedule,
      periodsCount: schedule?.periods.length,
      totalSlots: schedule?.totalSlots,
      mapSize: daySchedules.size,
      mapKeys: Array.from(daySchedules.keys()).slice(0, 5),
      schedule: schedule,
      fullScheduleReturn: schedule || null
    });
    
    return schedule || null;
  }, [daySchedules]);

  const getDayColor = useCallback((date: string): string => {
    const schedule = daySchedules.get(date);
    if (!schedule) return 'bg-gray-50 text-gray-400';
    if (schedule.hasSchedule) return 'bg-blue-50 text-blue-700 border-blue-200';
    return 'bg-gray-50 text-gray-600';
  }, [daySchedules]);

  const getDayTooltip = useCallback((date: string): string => {
    const schedule = daySchedules.get(date);
    if (!schedule || !schedule.hasSchedule) return 'Clique para configurar horários';
    
    const periods = schedule.periods.map(p => `${p.startTime.substring(0,5)}-${p.endTime.substring(0,5)}`).join(', ');
    return `Horários: ${periods} (${schedule.totalSlots} slots)`;
  }, [daySchedules]);

  return {
    getScheduleForDate,
    getDayColor,
    getDayTooltip
  };
};
